export class AdditionalSubscriptionAddingOpaque {
  additionalCardsCount: number;
  currentUserId?: bigint;

  constructor(additionalCardCount: any, currentUserId?: bigint) {
    this.additionalCardsCount = Number(additionalCardCount);
    this.currentUserId = currentUserId;
  }
}
